// extracted by mini-css-extract-plugin
export default {"notifyItem":"notifyItem__X2vkF","ndt":"ndt__da8sh","ntxt":"ntxt__IT7Sm"};